import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TestimonialProps {
  className?: string;
}

interface TestimonialItem {
  quoteKey: string;
  authorKey: string;
  companyKey: string;
}

const Testimonials: React.FC<TestimonialProps> = ({ className = '' }) => {
  const { t } = useTranslation();
  const [activeSlide, setActiveSlide] = useState(0);

  const testimonials: TestimonialItem[] = [
    {
      quoteKey: 'testimonial_1_quote',
      authorKey: 'testimonial_1_author',
      companyKey: 'testimonial_1_company'
    },
    {
      quoteKey: 'testimonial_2_quote',
      authorKey: 'testimonial_2_author',
      companyKey: 'testimonial_2_company'
    },
    {
      quoteKey: 'testimonial_3_quote',
      authorKey: 'testimonial_3_author',
      companyKey: 'testimonial_3_company'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(current => (current + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleDotClick = (index: number) => {
    setActiveSlide(index);
  };

  return (
    <div className={`testimonials-container ${className}`}>
      <div className="testimonials-slider">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`testimonial-slide ${index === activeSlide ? 'active' : ''}`}
            style={{
              opacity: index === activeSlide ? 1 : 0,
              transform: `translateX(${(index - activeSlide) * 100}%)`,
              position: index === activeSlide ? 'relative' : 'absolute'
            }}
          >
            <div className="testimonial-quote">"</div>
            <p className="testimonial-text">{t(testimonial.quoteKey)}</p>
            <div className="testimonial-author">
              <div className="author-name">{t(testimonial.authorKey)}</div>
              <div className="author-title">{t(testimonial.companyKey)}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`testimonial-dot ${index === activeSlide ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials; 